import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LeagueService {

    constructor(private http: HttpClient) { }

    /**
     * Get all leagues
     */
    getLeagues(isPublic: boolean) {
        return this.http.post<any>('api_endpoint' + '/league/index', { isPublic });
    }

    /**
     * Create league
     */
    create(leagueObj) {
        return this.http.post<any>('api_endpoint' + '/league/create', leagueObj);
    }
    
    /**
     * Get league
     */
    getLeague(leagueId, skipCache) {
        return this.http.post<any>('api_endpoint' + '/league/' + leagueId, { skipCache });
    }

    // Add owner
    addOwner(leagueId, phone, email) {
        return this.http.post<any>('api_endpoint' + '/league/add-owner', { leagueId, phone, email });
    }

    // BULK UPLOAD
    bulkUpload(leagueId, users) {
        return this.http.post<any>('api_endpoint' + '/league/bulk-upload', { leagueId, users });
    }

    // ADD TEAMS TO LEAGUE
    addTeamsToLeague(leagueId, teamIds) {
        return this.http.put<any>('api_endpoint' + '/league/add-teams-to-league', { leagueId, teamIds });
    }

    // REMOVE TEAM TO LEAGUE
    removeTeamFromLeague(leagueId, teamId) {
        return this.http.put<any>('api_endpoint' + '/league/remove-team-from-league', { leagueId, teamId });
    }

    // ADD TIES TO LEAGUE
    addTiesToLeague(leagueId, tieIds) {
        return this.http.put<any>('api_endpoint' + '/league/add-ties-to-league', { leagueId, tieIds });
    }
}
